import http from "../../http-common";

class DumpersDataService {

  upload(files, onUploadProgress) {
    let formData = new FormData();

    for(let i = 0; i < files.length; i++){
      formData.append('file', files[i]);
    }

    return http.post("/fichierdumpers/upload/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  }

  getFiles() {
    return http.get("/fichierdumpers/getListFiles");
  }

  getAll() {
    return http.get("/dumpers");
  }

  get(id) {
    return http.get(`/dumpers/${id}`);
  }

  create(data) {
    return http.post("/dumpers", data);

  }

  update(id, data) {
    return http.put(`/dumpers/${id}`, data);

  }

  delete(id) {
    return http.delete(`/dumpers/${id}`);
  }

  deleteAll() {
    return http.delete(`/dumpers`);
  }

  findByTitle(Nom) {
    return http.get(`/dumpers?nom=${Nom}`);
  }
}

export default new DumpersDataService();